import moment from 'moment'
import calendars from 'scoreboard/components/calendars'
import i18n from 'scoreboard/components/i18n'

var rangePathValidation = function (range) {
	if (!range) return
	//first distance/period must reference period on/before last
	var msg = 'report.customReport.error.outOfOrderCalendarPeriod.default'
	if (range.relative) {
		if (range.first > range.last) {
			return i18n.get(msg)
		}
	} else {
		var beginPeriod = calendars.periodsById[range.first]
		var endPeriod = calendars.periodsById[range.last]
		if (beginPeriod && endPeriod && moment(beginPeriod.end).isAfter(endPeriod.end, 'day')) {
			return i18n.get(msg)
		}
	}
}

export { rangePathValidation }
